import * as React from 'react';
import DataRoutes, { DataRoutesProps } from './DataRoutes';
import { useEditorRouterFilter } from '../../components/Editor/EditorRouterFiltersManager';
import { useCallback } from 'react';
import { DATA_EXPLORER_SIMULATE_CLASSNAME } from './dataExplorerConfig';

type Props = DataRoutesProps;

export const DataRoutesSimulate = ({ path, className }: Props) => {
  useEditorRouterFilter('dataExplorer');

  const resetScrollCallback = useCallback(() => {
    const element = document.getElementsByClassName(DATA_EXPLORER_SIMULATE_CLASSNAME)?.[0];
    if (element) {
      element.scrollTop = 0;
    }
  }, []);
  return <DataRoutes path={path} className={className} resetScrollCallback={resetScrollCallback} />;
};
